package one.healthium.today.ui.fodmap

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.combine
import kotlinx.coroutines.flow.update
import one.healthium.domain.user.UserInteractor
import one.healthium.healthKit.data.HealthKitHelper
import one.healthium.healthKit.data.HealthKitStatus
import one.healthium.healthKit.ui.HealthKitConnectBannerContract
import one.healthium.tasks.domain.DailyTasksRepository
import one.healthium.ui.common.vm.BaseViewModel
import one.primehealth.app.BaseAppConfig

internal class TodayViewModel(
    userInteractor: UserInteractor,
    tasksRepository: DailyTasksRepository,
    private val healthKitHelper: HealthKitHelper,
    baseAppConfig: BaseAppConfig,
) : BaseViewModel(), HealthKitConnectBannerContract {

    private val _state = MutableStateFlow(TodayUiState())
    val state = _state.asStateFlow()

    init {
        combine(
            userInteractor.observeUser(),
            tasksRepository.getDailyTasks(),
            healthKitHelper.healthKitStatus,
        ) { user, tasks, healthKitStatus ->
            _state.update { state ->
                state.copy(
                    user = user,
                    tasks = tasks,
                    healthKitStatus = if (baseAppConfig.features.healthKitEnabled()) healthKitStatus else HealthKitStatus.UNAVAILABLE,
                )
            }
        }.launch()
    }

    override fun onSkipClicked() {
        healthKitHelper.processSkipRequest()
    }
}